export default function GroceriesContent() {
  return (
    <>
      <h2>Why this template exists</h2>
      <p>
        Groceries isn't a retrospective format; it's a household board.
        Someone on the Retroboard team got tired of texting a photo of the
        pantry to their partner, and we realized the same collaborative-list
        machinery that powers a retro works just as well for coordinating
        who's picking up the milk. The columns cluster by store aisle so
        the shopper isn't backtracking.
      </p>

      <h2>When to use this template</h2>
      <p>
        Households, roommates, small teams planning meals, dinner parties
        that spiral. Anywhere multiple people are adding to the same list
        and you want a live shared surface instead of five parallel Notes
        apps and a text thread. Card-level voting doubles as "let's
        definitely get the good bread this time."
      </p>

      <h2>Not the right shape for</h2>
      <p>
        Real inventory management or serious meal planning. If you want
        recipe integration, nutrition tracking, or automatic reordering,
        use a purpose-built app. Groceries is a shared whiteboard, not a
        pantry OS.
      </p>

      <h2>How to run it</h2>
      <p>
        Everyone adds items as they come up during the week. Before the
        shopping trip, the person going scans the board, groups by aisle
        (already done for them by the columns), and marks off items in
        real time as they hit the cart. Any household that shops together
        should agree on who's the tie-breaker for "do we actually need
        this."
      </p>

      <h2>Common pitfalls</h2>
      <p>
        The board fills with aspirational items that never get bought.
        Reap the list monthly; anything that's been sitting for four
        weeks either wasn't important or should move to a "someday"
        column that's actually a separate board.
      </p>
    </>
  )
}
